import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Info, Sparkles, Bell, Zap } from "lucide-react";
import axios from "axios";
import { staggerContainer, staggerItem } from "@/config/animations";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TYPE_META = {
  feature: { icon: Sparkles, color: "var(--qn-primary)", bg: "var(--qn-primary-muted)" },
  update: { icon: Zap, color: "var(--qn-success)", bg: "var(--qn-success-muted)" },
  alert: { icon: Bell, color: "var(--qn-warning)", bg: "var(--qn-warning-muted)" },
  info: { icon: Info, color: "var(--qn-foreground-muted)", bg: "var(--qn-surface)" },
};

export default function Announcements() {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    axios.get(`${API}/announcements`).then(r => setAnnouncements(r.data)).catch(() => {});
  }, []);

  if (announcements.length === 0) return null;

  return (
    <Card className="card-themed" data-testid="announcements">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <Bell className="w-4 h-4 text-[var(--qn-foreground-muted)]" />
          <span className="text-sm font-semibold text-[var(--qn-foreground-muted)] uppercase tracking-wider">What's New</span>
        </div>
        <motion.div variants={staggerContainer} initial="initial" animate="animate" className="space-y-3">
          {announcements.slice(0, 3).map((a, i) => {
            const meta = TYPE_META[a.type] || TYPE_META.info;
            const Icon = meta.icon;
            return (
              <motion.div
                key={a.announcement_id || i}
                variants={staggerItem}
                className="flex items-start gap-3"
                data-testid={`announcement-${i}`}
              >
                <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: meta.bg }}>
                  <Icon className="w-4 h-4" style={{ color: meta.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium">{a.title}</div>
                  <p className="text-xs text-[var(--qn-foreground-muted)] mt-0.5 line-clamp-2">{a.body}</p>
                  <span className="text-[10px] text-[var(--qn-foreground-subtle)] mt-1 block">
                    {a.created_at ? new Date(a.created_at).toLocaleDateString() : ""}
                  </span>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </CardContent>
    </Card>
  );
}
